import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Col,
  Row,
  Tag,
  Divider,
  InputNumber,
  Switch,
  Space,
  message,
} from 'antd';
import { StoreContext } from '../store/index';
import { updateShift } from './api';
import { getDateFromTimestamp } from '../utils';
import PlayersList from '../components/PlayersList';

function AddPlayersModal({ shift, visible, onClose, onConfirm }) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;

  const { totalPlayers } = shift;

  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const onFinish = () => {
    onConfirm(players);
    onClose();
  };
  const handleAddPlayer = player => {
    let freeSpaces = totalPlayers / 2;
    shift.players.forEach(p => {
      if (player.isLocal === p.isLocal) {
        freeSpaces--;
      }
    });
    players.forEach(p => {
      if (player.isLocal === p.isLocal) {
        freeSpaces--;
      }
    });
    if (freeSpaces > 0) {
      setPlayers([
        ...players,
        {
          age: player.age,
          email: player.email,
          isLocal: player.isLocal,
          level: player.level,
          name: player.nickname,
          photoUrl: player.photoURL,
          position: player.position,
          userId: player.uid,
          goals: 0,
          absent: false,
          yellowCard: 0,
          redCard: false,
          invitedById: user.uid,
          invitedByName: user.nickname,
          invitedByPhotoUrl: user.photoURL,
        },
      ]);
    } else message.error('No hay lugares disponibles');
  };
  const handleRemovePlayer = player =>
    setPlayers(players.filter(p => p.userId !== player.userId));

  return (
    <Modal
      title="Agregar Jugadores"
      open={visible}
      onOk={onFinish}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <PlayersList
        header="Amigos"
        shift={shift}
        dataSource={user.friends.filter(
          f =>
            !shift.players.find(p => p.userId === f.uid) &&
            !shift.playRequests.find(p => p.userId === f.uid) &&
            !players.find(p => p.userId === f.uid),
        )}
        addPlayerModalAction={handleAddPlayer}
      />
      <Row align="middle">
        <Divider orientation="left" plain>
          <h3>{shift.localTeam.name}</h3>
        </Divider>
      </Row>
      <Row>
        {players
          .filter(p => p.isLocal)
          .map(item => (
            <Tag closeIcon onClose={() => handleRemovePlayer(item)}>
              {item.name}
            </Tag>
          ))}
      </Row>
      <Row align="middle">
        <Divider orientation="left" plain>
          <h3>{shift.visitTeam.name}</h3>
        </Divider>
      </Row>
      <Row>
        {players
          .filter(p => !p.isLocal)
          .map(item => (
            <Tag closeIcon onClose={() => handleRemovePlayer(item)}>
              {item.name}
            </Tag>
          ))}
      </Row>
    </Modal>
  );
}

export default AddPlayersModal;
